import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { FormListeners } from '../../../../models/beans/form-listeners.abstract';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { CkNormeValuesEnum } from '../../common/consts/ckNormeValues.enum';
import { setCommonAmmControlloListeners } from '../../listeners/amm-controllo-common.form-listeners';
import { my_CkNormeListenerHelper } from '../../listeners/amm-controllo-norme.listeners';
import { my_AllConsAmmCaricaListenerHelper, my_AllConsAmmDataElezioneListenerHelper, my_AmmUnicoCaricaListenerHelper } from '../../listeners/amm-controllo-consiglio-amm.listeners';
import {
    my_AllCollSindCaricaListenerHelper,
    my_AllCollSindCkRevisoreListenerHelper,
    my_AllCollSindCkSocioListenerHelper,
    my_AllElemCollegioSindacaleListenerHelper,
    my_AllRevisoriControlloContabileOrganoListenerHelper,
} from '../../listeners/amm-controllo-collegio-sindacale.listeners';
import { my_AllLiquidatoriCaricaListenerHelper } from '../../listeners/amm-controllo-liquidatori.listeners';
import {
    my_AllAmmUnComuneProvinciaCH,
    my_AllCollSindComuneProvinciaCH,
    my_AllConsAmmComuneProvinciaCH,
    my_AllLiquidatoriComuneCH,
} from '../../common/helpers/norme-comune-provincia.helper';
import { my_SrlCoop20SociListenerHelper, my_SrlCoop9SociListenerHelper } from '../../common/helpers/coop-soci-listener.helper';
import { setNormeSrlSpecificListeners } from './norme-srl-srl-specific.listeners';

export class NormeSrlFormListeners extends FormListeners {
    private readonly store: Store<Revisione53State>;

    constructor(form: FormGroup, store: Store<Revisione53State>) {
        super(form);
        this.store = store;
    }

    setListeners(): void {
        setNormeSrlSpecificListeners(this.form, this.store);
        setCommonAmmControlloListeners(this.form, this.store);
        my_AllAmmUnComuneProvinciaCH(this.form, this.store);
        my_AllElemCollegioSindacaleListenerHelper(this.form, this.store, CkNormeValuesEnum.normeSrl);
        my_AllCollSindCkRevisoreListenerHelper(this.form, this.store, true, CkNormeValuesEnum.normeSrl);
        my_AllLiquidatoriCaricaListenerHelper(this.form, this.store, CkNormeValuesEnum.normeSrl);
        my_AllCollSindCkSocioListenerHelper(this.form, this.store, CkNormeValuesEnum.normeSrl);
        my_AllRevisoriControlloContabileOrganoListenerHelper(this.form, this.store, CkNormeValuesEnum.normeSrl);
        my_AllConsAmmDataElezioneListenerHelper(this.form, this.store, CkNormeValuesEnum.normeSrl);
        my_CkNormeListenerHelper(this.form, this.store, CkNormeValuesEnum.normeSrl);
        my_AmmUnicoCaricaListenerHelper(this.form, this.store, CkNormeValuesEnum.normeSrl);
        my_AllCollSindComuneProvinciaCH(this.form, this.store);
        my_AllConsAmmComuneProvinciaCH(this.form, this.store);
        my_AllLiquidatoriComuneCH(this.form, this.store);
        my_AllConsAmmCaricaListenerHelper(this.form, this.store, CkNormeValuesEnum.normeSrl);
        my_AllCollSindCaricaListenerHelper(this.form, this.store, CkNormeValuesEnum.normeSrl);
        my_SrlCoop9SociListenerHelper(this.form, this.store);
        my_SrlCoop20SociListenerHelper(this.form, this.store);
    }
}
